import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AlbumGrid from "@/components/AlbumGrid";
import { ALBUMS } from "@/data/photos";
import { motion } from "framer-motion";
import { Users, Heart, Star } from "lucide-react";

export default function Equipe() {
  const album = ALBUMS.find((a) => a.id === "equipe")!;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[55vh] flex items-end pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <img src={album.cover} alt="Équipe FGNB" className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-t from-[oklch(0.15_0.08_280/0.95)] via-[oklch(0.2_0.07_280/0.6)] to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <span className="inline-block text-violet-400 text-sm font-semibold uppercase tracking-[0.15em] mb-3">Nos héros du quotidien</span>
            <h1 className="text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              L'Équipe <span className="text-violet-300">FGNB</span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center max-w-3xl mx-auto mb-16">
            <p className="text-muted-foreground leading-relaxed">
              Derrière chaque action humanitaire se trouvent des bénévoles et coordinateurs dévoués, portant fièrement les couleurs de la
              Fondation Gath Naël Beko. Leur engagement sans faille est le moteur de notre impact.
            </p>
          </motion.div>

          <div className="grid grid-cols-3 gap-6 mb-16">
            {[
              { icon: Users, label: "Bénévoles actifs", value: "50+" },
              { icon: Heart, label: "Missions réalisées", value: "30+" },
              { icon: Star, label: "Coordinateurs", value: "10+" },
            ].map(({ icon: Icon, label, value }) => (
              <motion.div key={label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                className="bg-card border border-border rounded-3xl p-6 text-center hover:border-violet-400/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-xl bg-violet-500/10 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-5 h-5 text-violet-500" />
                </div>
                <p className="text-3xl font-bold text-foreground mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{value}</p>
                <p className="text-xs text-muted-foreground">{label}</p>
              </motion.div>
            ))}
          </div>

          <div className="mb-6">
            <span className="inline-block text-accent text-sm font-semibold uppercase tracking-[0.15em] mb-2">Album photos</span>
            <h2 className="text-3xl font-bold text-foreground mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {album.title}
            </h2>
          </div>
          <AlbumGrid photos={album.photos} columns={3} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
